export const reviewTempData = {
    defaultRating: 5,
    nbReviewsToDisplay: 3,
    nbReviewsToDisplayPerClick: 3,
    reviewDisplayTextLength: 200,
};